module.exports = __webpack_public_path__ + "roles.1843fbe305a6ede2d97afea5c5095cb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/roles.svg
// module id = 1147
// module chunks = 0